import React, { useState } from 'react';
import ScreenDetails from './screen-details';

import useWeeklyRosterContext from 'contexts/weekly-roster.context';

const EditKitchenShiftCard = ({ shift, dept }: { shift: string; dept: string }) => {
  const { setAddRosterFormData, addRosterFormData } = useWeeklyRosterContext();

  const [open, setOpen] = useState(true);

  const handleRosterChange = (data: string[]) => {
    setAddRosterFormData(
      addRosterFormData.map((department) => {
        if (department.department === dept) {
          return {
            ...department,
            [shift]: data
          };
        }
        return department;
      })
    );
  };
  const shiftDetails = addRosterFormData.find((ros) => ros.department === dept)?.[
    shift as keyof (typeof addRosterFormData)[0]
  ] as string[];

  return (
    <div>
      <div className='flex items-center justify-between bg-[#F5F5F5] py-3 px-5 rounded-xl'>
        <p className='font-medium'>{shift?.toUpperCase()} SHIFT</p>
        <span
          className='bg-white text-center border border-[#E7E8E9] py-[5px] w-24 rounded-lg text-sm'
          role='button'
          onClick={() => setOpen(!open)}>
          {open ? 'Hide' : 'Show'}
        </span>
      </div>
      {open && (
        <div className='pt-8 bg-white'>
          <ScreenDetails staffs={shiftDetails ?? []} handleChange={handleRosterChange} />
        </div>
      )}
    </div>
  );
};

export default EditKitchenShiftCard;
